import { Add, Info } from '@mui/icons-material';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showBusinessNetwork } from 'services/redux/businessNetworkSlice';

import CustomButton from '../../../../../../../../lib/designSystem/Button';
import EnhancedTable from '../../../../../../../../lib/designSystem/Table';
import { cellFormat } from '../../../../../../../../lib/designSystem/Table/cellFormat';
import {
  formatMoney,
  hasAnyPermissions,
} from '../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../services/redux/authSlice';
import AddPendingAccountToFNC from '../AddPendingAccounts';
import DeleteFNCPendingAccountDialog from '../DeleteFNCPendingAccountDialog';

const NotRecognizedPaymentDetails = (props: any) => {
  const { notRecognizedPayment, setOpen, open, handleDetails } = props;
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [openAddInvoices, setOpenAddInvoices] = useState(false);
  const [openDeleteFNCPendingAccount, setOpenDeleteFNCPendingAccount] =
    useState(false);
  const [FNCPendingAccountId, setFNCPendingAccountId] = useState(0);

  const dispatch = useDispatch();

  const handleShowBusinessDetails = (id: string) => {
    const data = notRecognizedPayment.pendingAccounts;
    const row: any = data.find((x: any) => x.id === id);
    if (!row) return;
    dispatch(
      showBusinessNetwork({
        id: row.businessIdentifier,
        name: row.businessName,
      }),
    );
  };

  const handleDelete = async (id: number) => {
    setOpenDeleteFNCPendingAccount(true);
    setFNCPendingAccountId(id);
  };

  const canShowDelete = () => {
    if (hasAnyPermissions(user, ['financing_fnc_reverse'])) return true;
    return false;
  };

  const actions: any = [
    { action: handleDelete, actionLabel: 'Eliminar', canShow: canShowDelete },
  ];

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Pago no reconocido #{notRecognizedPayment.id}</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0px',
          }}
        >
          <Typography variant="body1" fontWeight="bold">
            Estado
          </Typography>
          <Typography variant="body1">
            {cellFormat(notRecognizedPayment.status, 'conciliation-status')}
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0px',
          }}
        >
          <Typography variant="body1" fontWeight="bold">
            Monto
          </Typography>
          <Typography variant="body1">
            {formatMoney(notRecognizedPayment.amount)}
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0px',
          }}
        >
          <Typography variant="body1" fontWeight="bold">
            Monto conciliado
          </Typography>
          <Typography variant="body1">
            {formatMoney(notRecognizedPayment.amountConciliated)}
          </Typography>
        </div>
        <Divider />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0px',
          }}
        >
          <Typography variant="body1" fontWeight="bold">
            FNCs dentro de este pago
          </Typography>
          <IconButton
            onClick={() => {
              setOpenAddInvoices(true);
            }}
            disabled={notRecognizedPayment.status !== 'Pendiente'}
          >
            <Add />
          </IconButton>
        </div>
        <div>
          {!notRecognizedPayment.pendingAccounts.length ? (
            <Typography variant="body1">
              No hay cuentas asociadas a este FNC
            </Typography>
          ) : (
            <EnhancedTable
              data={notRecognizedPayment.pendingAccounts}
              dataHeaders={[
                { key: 'id', label: 'Folio', type: 'numeric-id' },
                {
                  key: 'businessName',
                  label: 'Acreedor',
                  handleAction: handleShowBusinessDetails,
                  icon: <Info fontSize="small" />,
                },
                { key: 'businessIdentifier', label: 'Rut' },
                { key: 'createdAt', label: 'Creación', type: 'date' },
                { key: 'amount', label: 'Monto', type: 'money' },
              ]}
              actions={actions}
              showActions
            />
          )}
        </div>
      </DialogContent>
      <AddPendingAccountToFNC
        open={openAddInvoices}
        setOpen={setOpenAddInvoices}
        handleDetails={handleDetails}
        notRecognizedPayment={notRecognizedPayment}
        maxAmount={
          notRecognizedPayment.amount - notRecognizedPayment.amountConciliated
        }
      />
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          {' '}
          Cancelar{' '}
        </CustomButton>
      </DialogActions>
      {openDeleteFNCPendingAccount && (
        <DeleteFNCPendingAccountDialog
          open={openDeleteFNCPendingAccount}
          setOpen={setOpenDeleteFNCPendingAccount}
          FNCId={notRecognizedPayment.id}
          FNCPendingAccountId={FNCPendingAccountId}
          handleDetails={handleDetails}
        />
      )}
    </Dialog>
  );
};

export default NotRecognizedPaymentDetails;
